<template>
  <div class="WAttachmentUpload">
    <el-form :disabled="false">
      <div class="file-list">
        <el-scrollbar ref="scrollbar">
          <el-button
            class="file-item"
            v-for="(item, index) in itemValue.data"
            :key="index"
            @click="handleAttach"
          >
            <div class="float-tool-bar" v-if="!disabled && !formDisabledValue">
              <el-button
                type="text"
                icon="el-icon-view"
                @click="handleAttach"
              ></el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(index)"
              ></el-button>
            </div>
            <el-tooltip effect="dark" :content="item.name" placement="top">
              <i class="el-icon el-icon-document"></i>
            </el-tooltip>
          </el-button>
        </el-scrollbar>
      </div>
    </el-form>

    <div
      class="upload"
      @click="handleInput"
      v-if="!disabled && !formDisabledValue"
    >
      <el-button icon="el-icon-plus"></el-button>
    </div>
    <input
      class="inputer"
      type="file"
      multiple
      :accept="accept"
      @change="handleFileChange"
      ref="inputer"
    />
    <AttachViewer
      v-if="visible"
      ref="AttachViewer"
      :previewType="previewType"
      @closed="handleClosed"
    />
  </div>
</template>

<script>
import AttachViewer from '@/components/AttachViewer'
import upload from './mixin/upload'
export default {
  name: "WAttachmentUpload",
  components: {
    AttachViewer
  },
  mixins: [upload],
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    display: {
      type: String,
      default: "single",
    },
    accept: {
      type: String,
      default: "*",
    },
    size: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
  },
  computed: {
  },
  data() {
    return {
      iconMap: {
        'pdf': '',
        'image': '',
        'svg': ''
      },
      fileList: [],
      url: undefined,
      formData: undefined,
      files: []
    };
  },
  methods: {
    // 删除图片
    handleDelete(index) {
      this.itemValue.data.splice(index, 1)
      this.$emit('handleUpdate')
    },
    // 文件预览
    handleAttach() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.AttachViewer.previewAttach(this.value.data)
      })
    },
    handleInput() {
      this.$refs.inputer.click()
    },
    handleFileChange() {
      let inputDOM = this.$refs.inputer;
      this.files = []
      for (let i = 0; i < inputDOM.files.length; i++) {
        if (this.beforeUpload(inputDOM.files[i])) {
          this.files.push(inputDOM.files[i])
        }

      }

      this.handleUpload(this.files)
      inputDOM.value = null
    },
  },
};
</script>

<style lang="scss">
.WAttachmentUpload {
  height: 100%;
  width: 100%;
}
.WAttachmentUpload::after {
  content: "";
  clear: both;
}
.WAttachmentUpload .file-list {
  float: left;
  max-width: calc(100% - 68px);
  margin-right: 10px;
}
.WAttachmentUpload .upload {
  height: 58px;
  width: 58px;
  text-align: center;
  float: left;
}
.WAttachmentUpload .el-button {
  width: 100%;
  height: 100%;
  font-size: 24px;
  padding: 0;
  /* margin: 0 10px 0 0; */
}
.WAttachmentUpload .file-item {
  display: inline-block;
  height: 58px;
  width: 58px;
  text-align: center;
  position: relative;
  &:hover .float-tool-bar {
    display: block;
  }
  .float-tool-bar {
    display: none;
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      z-index: 2;
    }
    .el-button {
      width: auto;
      color: #fff;
      margin: 0 1px;
      font-size: 16px;
      position: relative;
      z-index: 3;
    }
  }
}

.WAttachmentUpload .inputer {
  display: none;
}
.WAttachmentUpload .el-scrollbar {
  height: 100%;
  width: 100%;
}
.WAttachmentUpload .el-scrollbar__view {
  white-space: nowrap;
}
</style>